import { AssigneeResponse } from "interfaces/Mueller.Business.Models";
import { HTTP_GET, WebApiRequest } from "tools/webservice";


export const getInspectorDetails = (inspectorNumber: number, successCallback:(regions: AssigneeResponse) => void, mountedRef: { current: boolean }) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/assignment/insurance/inspector/${inspectorNumber}`,
  successCallback,
  mountedRef,
});
